import React from "react";
import "./input.scss";
import InputLabel from "./InputLabel";
import classNames from "classnames";
import Validations from "../validations/Validations";
import { withDefaults } from "../../utils/withDefaults";
import type { Placement } from "@popperjs/core";

export interface InputProps {
  label?: string;
  helpText?: string;
  helpTextPlacement?: Placement;
  placeholder?: string;
  id?: string;
  type?: React.HTMLInputTypeAttribute;
  initialValue?: string;
  ariaLabel?: string;
  name?: string;
  required?: boolean;
  value?: string;
  validations?: string[];
  setValidations?: (validations: string[]) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  usePermanentAccent?: boolean;
  className?: string;
  reference?: React.Ref<HTMLInputElement>;
}

export default function Input(incomingProps: InputProps) {
  const props = withDefaults(incomingProps, inputDefaultProps);

  const allValidations = props.validations;

  return (
    <div className="input-field">
      {props.label ? (
        <InputLabel
          label={props.label}
          helpText={props.helpText}
          helpTextPlacement={props.helpTextPlacement}
          isRequired={props.required}
        />
      ) : null}
      <input
        ref={props.reference}
        placeholder={props.placeholder}
        id={props.id}
        type={props.type}
        name={props.name}
        aria-label={props.ariaLabel}
        value={props.value}
        onChange={props.onChange}
        required={props.required}
        onKeyDown={props.onKeyDown}
        onKeyPress={props.onKeyPress}
        onBlur={props.onBlur}
        className={classNames(
          "text-input",
          allValidations.length > 0 ? "has-validation-error" : "",
          props.usePermanentAccent ? "uses-permanent-accent" : "",
          props.className
        )}
      />
      <Validations validations={allValidations} />
    </div>
  );
}

const inputDefaultProps = {
  label: "",
  helpText: "",
  helpTextPlacement: "bottom" as Placement,
  placeholder: "",
  id: "0",
  type: "text",
  initialValue: "",
  ariaLabel: "input-field",
  name: "0",
  required: false,
  value: "",
  validations: [] as string[],
  setValidations: () => {},
  onChange: () => {},
  onKeyPress: () => {},
  onKeyDown: () => {},
  onBlur: () => {},
  usePermanentAccent: false,
  className: ""
};
